/* eslint-disable */ // TODO
import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./NotFoundPage.scss";
import { Button } from "components/controls";

export default class NotFoundPage extends Component {
  static propTypes = {
    router: PropTypes.object.isRequired
  };

  render() {
    return (
      <div className={styles.notFound}>
        <div className={styles.notFoundBackground}>404</div>
        <div className={styles.notFoundContent}>
          <div className={styles.notFoundHeader}>Page not found</div>
          <div className={styles.notFoundDescription}>
            The resource requested could not be found on this server!
          </div>

          <Button label="Return to home" onClick={this.goHome} />
        </div>
      </div>
    );
  }

  goHome = () => {
    this.props.router.replace("/");
  };
}



// WEBPACK FOOTER //
// ./src/components/layouts/NotFoundPage.js